import React from "react";
import PropTypes from "prop-types";
import { Card, Select, Divider } from "antd";
import { Table } from "components";
import { OrderedMap, List } from "immutable";
import XLSXDownloader from "components/xls-downloader";
import { formatCurrencyWithLabels } from "utilities/currency";
import {
    SALES_ANALYSIS_DISPLAY_YEAR,
    SALES_ANALYSIS_DISPLAY_CURRENCY
} from "constants/enums";
import _startCase from "lodash/startCase";
import CompanyService from "services/company-service";

import {
    TotalRepaymentRecord
} from "records/supply-chain-record";

const REPAYMENT_TABLE_COLS = new OrderedMap({
    year: {
        title: "Year",
        dataIndex: "year",
        key: "year",
        width: 100,
        // fixed: "left",
        render: _ => _
    },
    total_sales: {
        title: "Total Repayment",
        dataIndex: "total_sales",
        key: "total_sales",
        // fixed: "left",
        width: 150,
        // eslint-disable-next-line react/display-name
        render: _ => (<b>{+_ ? formatCurrencyWithLabels(_, "IN LACS") : "--"}</b>)
    }
});


const CurrencyOptions = SALES_ANALYSIS_DISPLAY_CURRENCY.map((v, k) => ({
    title: k,
    key: String(v)
}));
// new OrderedMap({
//     in_lacs: {
//         title: "In Lacs",
//         dataIndex: "in_lacs",
//         key: "in_lacs"
//     },
//     in_cr: {
//         title: "In Cr",
//         dataIndex: "in_cr",
//         key: "in_cr"
//     },
//     no_label: {
//         title: "Full Number",
//         dataIndex: "no_label",
//         key: "no_label"
//     }
// });

const tradeMonthColGenerator = (month, currencySelected) => ({
    title: month,
    dataIndex: month,
    key: month,
    render: _ => (+_ ? formatCurrencyWithLabels(_, currencySelected) : "--"),
    width: 100
});

const CurrencySelector = props => (
    <Select value={props.value} onSelect={props.onSelect}>
        {CurrencyOptions.map(_ => (
            <Select.Option key={_.key} value={_.key}>
                {_.title}
            </Select.Option>
        ))
            .toList()
            .toJS()}
    </Select>
);
CurrencySelector.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.string
};

const YearTypeSelector = props => (
    <Select
        value={props.value}
        onSelect={props.onSelect}
        disabled={props.disabled}
    >
        {SALES_ANALYSIS_DISPLAY_YEAR.map((v, k) => (
            <Select.Option key={v} value={String(v)}>
                {k}
            </Select.Option>
        ))
            .toList()
            .toArray()}
    </Select>
);

YearTypeSelector.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.string,
    disabled: PropTypes.bool
};
class TotalRepayment extends React.Component {
    state = {
        loading: false,
        data: new List([]),
        yearType: "0",
        currencySelected: "in_lacs",
        totalRepaymentApiData: new TotalRepaymentRecord({}),
        repaymentCols: REPAYMENT_TABLE_COLS,
        displayYear: 1,
        displayCurrency: 1,
    };
    tableCols = REPAYMENT_TABLE_COLS;
    componentDidMount() {
        this.setState({loading: true});
        CompanyService.getTotalRepaymentDetails(this.props.caseId).then(res=>{
            const resList = res.status === 200 && new List(res && res.data);
            const totalRepaymentData=  new TotalRepaymentRecord({
                data: resList
            });
            this.setState({totalRepaymentApiData: totalRepaymentData, loading: false});
            this.handleDataFetch(totalRepaymentData);
        }).catch((err) => {
            this.setState({loading: false});
            console.log("inside catch", err);
        });
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.displayCurrency != this.state.displayCurrency){
            this.handleDataFetch(prevState.totalRepaymentApiData);
        }
    }

    handleDataFetch = (apiData) =>{
        this.createTableCols(
            apiData && apiData.getCols(Number(this.state.displayCurrency))
        );
        this.setState({data: apiData && apiData.getRows(this.state.displayYear)});
    }

    onYearSelect = yearType => {
        this.setState({displayYear: yearType});
    };

    onCurrencySelect = selectedCurrency => {
        this.setState({displayCurrency:selectedCurrency});
    };

    tableCols = REPAYMENT_TABLE_COLS.set("total_sales", {
        ...REPAYMENT_TABLE_COLS.get("total_sales"),
        render: _ =>
            +_
                ? <b>{formatCurrencyWithLabels(
                    _,
                    SALES_ANALYSIS_DISPLAY_CURRENCY.findKey(
                        __ => __ === +this.state.displayCurrency
                    )
                )}</b>
                : "--"
    });
    createTableCols = cols => {
        cols &&
            cols.map(_ =>
                !["year", "total_sales"].includes(_)
                    ? (this.tableCols = this.tableCols.set(
                        _,
                        tradeMonthColGenerator(
                            _,
                            SALES_ANALYSIS_DISPLAY_CURRENCY.findKey(
                                __ => __ === +this.state.displayCurrency
                            )
                        )
                    ))
                    : null
            );
    };

    render() {
        return (
            <React.Fragment key={"parent"}>
                <Card
                    small={"size"}
                    className={"padless-card no-border-transparent flex-row-extra"}
                    title={"Total Repayments"}
                    extra={[
                        <React.Fragment key={"extra"}>
                            <React.Fragment>
                                <XLSXDownloader
                                    cols={this.tableCols}
                                    data={this.state.data}
                                />
                                <Divider type={"vertical"} />
                                {/* <YearTypeSelector
                                    key={"year-selector"}
                                    value={this.state.displayYear}
                                    onSelect={this.onYearSelect}
                                    // disabled={this.state.salesDisplayDisabled}
                                /> */}
                                <CurrencySelector
                                    key={"curr-selector"}
                                    value={
                                        _startCase(SALES_ANALYSIS_DISPLAY_CURRENCY.findKey(_ => {
                                            return _ == this.state.displayCurrency;
                                        }).toLowerCase())
                                    }
                                    onSelect={this.onCurrencySelect}
                                />
                            </React.Fragment>
                        </React.Fragment>
                    ]}
                >
                    <Table
                        size={"small"}
                        columns={this.tableCols}
                        checkedColumns={[]}
                        data={this.state.data}
                        showTitle={false}
                        showTopSection={false}
                        pagination={false}
                        keyFilter={"id"}
                        loading={this.state.loading}
                        editable={true}
                        noRowSelection={true}
                        bordered={false}
                    />
                </Card>
            </React.Fragment>
        );
    }
}

TotalRepayment.propTypes = {
    caseId: PropTypes.number,
};

export default TotalRepayment;

